import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { API_BASE_URL } from '../api';

// Module-level singleton — one socket per tab, shared by all components.
// Auth uses the same JWT as the axios instance; CRA's dev proxy forwards the
// /socket.io upgrade to the API server, production is same-origin.
let socket = null;

export function getSocket() {
  if (!socket) {
    const configuredSocketUrl = process.env.REACT_APP_SOCKET_URL;
    const apiOrigin = API_BASE_URL.startsWith('http')
      ? new URL(API_BASE_URL).origin
      : '/';
    socket = io(configuredSocketUrl || apiOrigin, {
      auth: { token: localStorage.getItem('token'), workspaceId: localStorage.getItem('active_workspace') },
      autoConnect: true,
    });
    socket.on('workspace:revoked', () => {
      localStorage.removeItem('active_workspace');
      window.dispatchEvent(new Event('workspace:revoked'));
    });
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

// Subscribe to a socket event for the lifetime of the component.
export function useSocketEvent(event, handler) {
  useEffect(() => {
    const s = getSocket();
    s.on(event, handler);
    return () => s.off(event, handler);
  }, [event, handler]);
}
